import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LoadingState, getError } from 'app/utils/callstate';
import * as _ from 'lodash';
import { PayrollExtraState } from '../payroll.types';
import { RouteState, State, fromPayrollExtra } from '../reducers';
import { PayrollExtraEntry } from 'app/api/payroll.extra.api.service';

export const getRouteState = createFeatureSelector<State, RouteState>(
  'payroll'
);

export const selectPayrollExtraState = createSelector(
  getRouteState,
  ({ apiExtra }): PayrollExtraState => apiExtra
);

export const selectPayrollExtra = createSelector(
  selectPayrollExtraState,
  fromPayrollExtra.selectAll
);

export const selectPayrollExtraByCompany = (companyId: string) =>
  createSelector(selectPayrollExtra, (payrollExtras: PayrollExtraEntry[]) =>
    {
      return _.filter(payrollExtras, (entry) => {
        return entry.companyId === companyId;
      });
    }
  );

export const selectPayrollExtraLoading = createSelector(
  selectPayrollExtraState,
  (payrollExtraState) => {
    return payrollExtraState.callState === LoadingState.Loading;
  }
);

export const selectPayrollExtraLoaded = createSelector(
  selectPayrollExtraState,
  (payrollExtraState) => payrollExtraState.callState === LoadingState.Loaded
);

export const selectPayrollExtraError = createSelector(
  selectPayrollExtraState,
  (payrollState) => getError(payrollState.callState)
);
